var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.71777L14.5471 4.31891L8.13218 10.7146L5.58463 8.17471L11.9996 1.71777Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8669 5.57361L18.4145 8.17474L8.13218 18.4263L5.58463 15.8863L15.8669 5.57361Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26469 9.42926L6.81225 12.0304L4.26469 14.5703L1.71713 12.0304L4.26469 9.42926Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7343 9.42926L22.2819 12.0304L11.9996 22.2819L9.45203 19.742L19.7343 9.42926Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/BUSD.62b5cac4358a8d33ef311f7e3ad1f79e.svg";
export { ForwardRef as ReactComponent };